import {MODALS_IDS} from '@Components/modal-container';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import type {EmailMakerMobileControlModalProps} from './email-maker-mobile-control-modal.types';

// Rendered by the pre-mounted EmailMakerMobileControlSheet; this only resolves the modal-render import.
export default function EmailMakerMobileControlModalNoop(): null {
  return null;
}

// eslint-disable-next-line react-refresh/only-export-components
export const openEmailMakerMobileControlModal = (props: EmailMakerMobileControlModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.EMAIL_MAKER_MOBILE_CONTROL_MODAL,
      panelProps: props,
    })
  );
};
